import { useEffect, useRef } from "react";
import { ActivityFormSection } from "./ActivityFormModel";

/**
 * Refs for the sections that can hold an error, plus the scroll that brings the offending one into view.
 * The responsible error is rendered as its own element rather than as an errored input, so there is
 * no single DOM class that finds every failure - the section the model rejected is what gets scrolled to.
 */
export function useScrollToInvalidSection(firstInvalidSection: ActivityFormSection | undefined, validationAttempt: number) {
    const basicsRef = useRef<HTMLDivElement>(null);
    const scheduleRef = useRef<HTMLDivElement>(null);
    const peopleRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const refsBySection = { basics: basicsRef, schedule: scheduleRef, people: peopleRef };
        const target = firstInvalidSection ? refsBySection[firstInvalidSection] : undefined;

        target?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        // eslint-disable-next-line
    }, [validationAttempt]);

    return { basicsRef, scheduleRef, peopleRef };
}
